export const SERVICE_WEBINAR_CHECKOUT_FLOW = 'service_webinar';

export const DEFAULT_WEBINAR_JOIN_RELEASE_MINUTES = 15;

export const DEFAULT_WEBINAR_DURATION_MINUTES = 60;

export function computeWebinarEndsAt(startsAt: Date, durationMinutes: number): Date {
  return new Date(startsAt.getTime() + durationMinutes * 60_000);
}

export function computeWebinarJoinReleaseAt(
  startsAt: Date,
  joinLinkReleaseMinutes = DEFAULT_WEBINAR_JOIN_RELEASE_MINUTES,
): Date {
  return new Date(startsAt.getTime() - joinLinkReleaseMinutes * 60_000);
}

export function isWebinarJoinAvailable(
  startsAt: Date,
  durationMinutes: number,
  joinLinkReleaseMinutes = DEFAULT_WEBINAR_JOIN_RELEASE_MINUTES,
  now = new Date(),
): boolean {
  const releaseAt = computeWebinarJoinReleaseAt(startsAt, joinLinkReleaseMinutes);
  const endsAt = computeWebinarEndsAt(startsAt, durationMinutes);
  return now.getTime() >= releaseAt.getTime() && now.getTime() < endsAt.getTime();
}

export function validateWebinarOfferPublish(input: {
  title: string;
  priceCents: number;
  refundPolicyText?: string | null;
  startsAt?: Date | null;
  capacity?: number | null;
  durationMinutes?: number | null;
  meetingProvider?: string | null;
  manualMeetingUrl?: string | null;
  sharedMeetingUrl?: string | null;
}): { errors: string[]; warnings: string[] } {
  const errors: string[] = [];
  const warnings: string[] = [];

  if (!input.title.trim()) errors.push('Title is required');
  if (input.priceCents > 0 && !input.refundPolicyText?.trim()) {
    errors.push('Refund policy is required for paid offers');
  }
  if (!input.startsAt || Number.isNaN(input.startsAt.getTime())) {
    errors.push('Session date and time are required');
  } else if (input.startsAt.getTime() <= Date.now()) {
    errors.push('Webinar must be scheduled in the future');
  }
  if (!input.capacity || input.capacity < 1) {
    errors.push('Capacity must be at least 1');
  }
  if (!input.durationMinutes || input.durationMinutes < 15 || input.durationMinutes > 480) {
    errors.push('Duration must be between 15 and 480 minutes');
  }
  if (
    input.meetingProvider === 'manual' &&
    !input.manualMeetingUrl?.trim() &&
    !input.sharedMeetingUrl?.trim()
  ) {
    warnings.push('Add a manual meeting URL or connect a meeting provider before going live');
  }

  return { errors, warnings };
}

export const SERVICE_WEBINAR_ANALYTICS_EVENT = {
  REGISTERED: 'webinar.registered',
  ATTENDED: 'webinar.attended',
} as const;
